import {
  ENDPOINT_AUTHENTICATION_TWO_FACTOR_PASSPORT_POST,
  MagicLoginErrors,
} from '../../constants';
import { wagApi } from '../../types/wagapi';
import {
  buildApiErrorPipeline,
  mapErrorByType,
  mapErrorToApiSlice,
  mapSliceErrorToV5,
  unwrapSliceError,
} from '../../utils/buildApiErrorPipeline';
import { createErrorForV5 } from '../../utils/buildApiErrorPipeline/createErrorForV5';
import { tryCatch } from '../../utils/tryCatch';
import { apiSlice } from '../apiSlice';

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    postAuthenticationTwoFactorPassword: builder.mutation<
      wagApi.PostAuthenticationTwoFactorPasswordResponse,
      wagApi.PostAuthenticationTwoFactorPasswordPayload
    >({
      queryFn: async (body, _api, _extraOptions, query) => {
        const adjustedArgs = {
          url: ENDPOINT_AUTHENTICATION_TWO_FACTOR_PASSPORT_POST,
          method: 'POST',
          body,
        };
        const [response] = await tryCatch(() => query(adjustedArgs));

        if (response.error) {
          return buildApiErrorPipeline(response.error)
            .pipe(
              unwrapSliceError,
              mapSliceErrorToV5,
              createErrorForV5,
              mapErrorByType(MagicLoginErrors.PasswordFlow),
              mapErrorToApiSlice,
            );
        }
        return response;
      },
    }),
  }),
  overrideExisting: false,
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  usePostAuthenticationTwoFactorPasswordMutation,
} = authApi;
